export class ExecutorES6{
  nbThread : number;
  queue : (()=>Promise<any>)[];
  running : Promise<any>[];
  
  constructor(nbThread :number){
    this.nbThread = nbThread||1;
    this.queue = [];
    this.running = [];
  }
  async push<T>(promiseBuilder : ()=>Promise<T>){
    var promise = new Promise<T>((resolve,reject)=>{
      this.queue.push(()=>promiseBuilder().then(resolve).catch(reject));
    })
    this._dequeue();
    return promise;
  }
  _dequeue(){
    var freeSlot = Math.min(this.nbThread - this.running.length,this.queue.length)
    for(var i=0;i<freeSlot;i++){
      var promise = this.queue.shift()().finally(()=>{
        this.running.splice(this.running.indexOf(promise),1);
        this._dequeue();
      });
      this.running.push(promise)
    }
  }
  clearQueue(){
    this.queue = []
  }
}
  